import { render, staticRenderFns } from "./DynamicTradeCriteria.vue?vue&type=template&id=5bbbd2ef"
import script from "./DynamicTradeCriteria.vue?vue&type=script&lang=js"
export * from "./DynamicTradeCriteria.vue?vue&type=script&lang=js"
import style0 from "./DynamicTradeCriteria.vue?vue&type=style&index=0&id=5bbbd2ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports